// extracted by mini-css-extract-plugin
export default {"button":"button_button__7B485","buttonSmall":"button_buttonSmall__yvmDu"};